import type { NativeTranscriptEvent } from '@ai-meeting/shared'
import type { RealtimeToken } from '@soniox/client'
import { proxyEventToTokens } from './proxySttEventProcessor'

export interface NativeRealtimeToken extends RealtimeToken {
  native_event_id: string
  native_sequence?: number
  speaker_name: string
}

export function nativeTranscriptToToken(event: NativeTranscriptEvent): NativeRealtimeToken {
  const speakerName = event.speakerName || 'Unknown speaker'
  const mapped = proxyEventToTokens({
    event: event.isFinal ? 'transcript.final' : 'transcript.partial',
    text: event.text,
    speaker: event.speakerId ?? event.participantId ?? 'unknown',
    speaker_name: speakerName,
    start_time: event.startTimeMs / 1000,
    language: event.languageCode,
  })
  const token = (event.isFinal ? mapped.finalTokens : mapped.partialTokens)[0]

  return {
    ...token,
    confidence: event.confidence ?? 0,
    speaker_name: speakerName,
    end_ms: event.endTimeMs,
    native_event_id: event.providerEventId,
    native_sequence: event.sequence,
  } as NativeRealtimeToken
}
